// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__QJw-C","amount":"Amount_amount__3lsJj","tip":"Amount_tip__kZbV-","tipHeader":"Amount_tipHeader__CgRcK","tipsWrap":"Amount_tipsWrap__31QUa"};